<!--check_48dp_FILL0_wght700_GRAD0_opsz48-->
<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px">
    <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"/>
  </svg>
</template>
